import { render, staticRenderFns } from "./MyOrderList.vue?vue&type=template&id=d2e5100a&scoped=true&"
import script from "./MyOrderList.vue?vue&type=script&lang=js&"
export * from "./MyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderList.vue?vue&type=style&index=0&id=d2e5100a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e5100a",
  null
  
)

export default component.exports